import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const appRoot = document.getElementById('root');

setupDevelopmentTools();
renderApplication();

function renderApplication() {
  if (appRoot) {
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      appRoot,
    );
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Wrap development block with dev mode check - terser gets rid of this block during production build
/* istanbul ignore next */
function setupDevelopmentTools() {
  if (process.env.NODE_ENV === 'development') {
    import('@op/local-development-environment/setup').then(({ setup }) => setup({ APP_ROOT_ID: 'root', renderApplication }));
  }
}
